import { Navigate } from 'react-router-dom';

const Root = () => {
    return <Navigate to="/dashboard/vitale" replace />;
};

export default Root;
